module.exports = __webpack_public_path__ + "media/react/marketing/pages/plans/gre/sections/social_proof/assets/star_icon-237c4d9bdaba05f43474170e8503c755.svg";